<template>
  <div>
    <rest-form-item
      :label="$t('ChannelConfig_Generic_Endpoint')"
      prop="endpoint"
    >
      <el-input
        v-model="model.params.endpoint"
        :placeholder="$t('ChannelConfig_Generic_Endpoint_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Generic_AuthType')"
      prop="authtype"
    >
      <enum-select
        v-model="model.params.authtype"
        :change="onChangeType()"
        :options="GenericAuthenticationTypesLabels"
      />
    </rest-form-item>
    <el-row v-if="model.params.authtype === 'basic'">
      <rest-form-item
        :label="$t('ChannelConfig_Generic_Username')"
        prop="username"
      >
        <el-input
          v-model="model.params.username"
          :placeholder="$t('ChannelConfig_Generic_Username_Placeholder')"
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('ChannelConfig_Generic_Password')"
        prop="password"
      >
        <el-input
          v-model="model.params.password"
          :placeholder="$t('ChannelConfig_Generic_Password_Placeholder')"
        />
      </rest-form-item>
    </el-row>
    <el-row
      v-if="model.params.authtype != 'basic' && model.params.authtype != 'none'"
    >
      <rest-form-item :label="$t('ChannelConfig_Generic_Token')" prop="token">
        <el-input
          v-model="model.params.token"
          :placeholder="$t('ChannelConfig_Generic_Token_Placeholder')"
        />
      </rest-form-item>
    </el-row>
    <rest-form-item
      :label="$t('ChannelConfig_Generic_SignatureSecret')"
      prop="signature_secret"
    >
      <el-input
        v-model="model.params.signature_secret"
        :placeholder="$t('ChannelConfig_Generic_SignatureSecret_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Generic_SignatureRequired')"
      :description="$t('ChannelConfig_Generic_SignatureRequired_Desc')"
      prop="signature_required"
    >
      <el-switch
        class="switch"
        v-model="model.params.signature_required"
        data-qa="signature-required"
        :active-value="true"
        :inactive-value="false"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('Integrations_Text_UseStaticIP')"
      :description="$t('Integrations_Text_UseStaticIP_Desc')"
      prop="use_static_ip"
    >
      <el-switch
        class="switch"
        v-model="model.params.use_static_ip"
        data-qa="use-static-ip"
        :active-value="true"
        :inactive-value="false"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'
import EnumSelect from '@/common/components/form/EnumSelect'
import { GenericAuthenticationTypesLabels } from '@/modules/channels/enum/AuthenticationTypesEnum'
import store from '@/core/store'

export default {
  components: {
    RestFormItem,
    EnumSelect
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (this.isCreatePage()) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'generic')
      this.$set(this.model, 'params', {
        use_static_ip: false,
        signature_required: false,
        authtype: 'bearer'
      })
    }
  },

  data() {
    return {
      GenericAuthenticationTypesLabels
    }
  },

  computed: {
    isProxyEnabled() {
      return store.state.app.proxy ? store.state.app.proxy['enabled'] : null
    }
  },

  methods: {
    isCreatePage() {
      return !this.$route.query.id
    },
    onChangeType() {
      if (this.model.params.authtype !== 'basic') {
        this.$set(this.model.params, 'username', null)
        this.$set(this.model.params, 'password', null)
      }
      if (this.model.params.authtype === 'none') {
        this.$set(this.model.params, 'token', null)
      }
    }
  }
}
</script>
<style scoped>
.field-ct {
  display: flex;
  align-self: center;
  column-gap: 15px;
  margin-left: -15px;
}
.el-row {
  margin: 0 !important;
}
.switch {
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/modules/channels/providers/Generic.vue